<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card outlined>
          <media-gallery
            :select-mode="false"
            :readonly="false"
            :per-page="48"
            :query-page="query.params.page"
            :query-search="query.params.search"
            @select="onImageClick"
            @page-change="onPageChange"
            @refresh="onRefresh"
            @search="onSearchInput"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QueryParamsHandler from '@/mixins/query-params-handler'
import MediaGallery from '@/components/media-gallery'

export default {
  name: 'MediaGalleryView',
  components: { MediaGallery },
  mixins: [QueryParamsHandler],
  data: () => ({
    defaultQuery: {
      page: undefined,
      search: undefined,
    },
    queriesDefined: ['page', 'search'],
    queryDefaults: ['page', 'search'],
    queryTypes: { page: 'number' },
    query: {
      params: {
        page: undefined,
        search: undefined,
      },
    },
  }),
  methods: {
    onImageClick(image) {
      this.$router.push({ name: 'tools.media-gallery.view', params: { id: image.uuid } })
    },
    onPageChange(page) {
      this.query.params.page = page
    },
    onRefresh() {
      this.query.params.page = undefined
      this.query.params.search = null
    },
    onSearchInput(value) {
      this.query.params.page = undefined
      this.query.params.search = value
    },
  },
}
</script>
